import { createReducer } from 'redux-act';
import { reject, append, equals, prepend } from 'ramda';
import { SORT_NEWEST_ID, IChip } from '@alycecom/ui';

import { GIFT_TYPES_FILTER } from '../../../constants/filters.constants';
import { IFilters } from '../../../store/products/products.types';

import { setSearch, setSorting, toggleTab, setFilter, addChip, deleteChip } from './filters.actions';

export interface IFiltersState {
  sort: number;
  search: string;
  filters: IFilters;
  filterChips: IChip[];
  opened: string[];
}

export const initialState = {
  sort: SORT_NEWEST_ID,
  search: '',
  filters: {
    brands: [],
    categories: [],
    giftTypes: [],
  },
  filterChips: [],
  opened: [GIFT_TYPES_FILTER.key],
};

const reducer = createReducer<IFiltersState>({}, initialState);

reducer
  .on(setSearch, (state, payload) => ({
    ...state,
    search: payload,
  }))
  .on(setSorting, (state, payload) => ({
    ...state,
    sort: payload,
  }))
  .on(setFilter, (state, payload) => ({
    ...state,
    filters: {
      ...state.filters,
      [payload.key]: payload.items,
    },
  }))
  .on(toggleTab, (state, payload) => ({
    ...state,
    opened: payload.isOpen ? reject(equals(payload.name), state.opened) : append(payload.name, state.opened),
  }))
  .on(addChip, (state, payload) => ({
    ...state,
    filterChips: prepend(payload, state.filterChips),
  }))
  .on(deleteChip, (state, payload) => ({
    ...state,
    filterChips: reject((chip: IChip) => chip.name === payload.name && chip.id === payload.id, state.filterChips),
  }));

export default reducer;
